// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAJF6G9W5tIBhQtOFrjjAbRH3ELliSfsTA",
  authDomain: "gabinet-agnieszka-polis.firebaseapp.com",
  projectId: "gabinet-agnieszka-polis",
  storageBucket: "gabinet-agnieszka-polis.appspot.com",
  messagingSenderId: "1099318613448",
  appId: "1:1099318613448:web:39c5c588422c849f595cfd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);